import _ from 'lodash';
import React from 'react';
import { FormGroup, FormControl, HelpBlock, Button } from 'react-bootstrap';

const EmailSubscription = React.createClass({

  getInitialState() {
    return {
      email: '',
      help: undefined
    };
  },

  render() {
    const { email, help } = this.state;
    return(
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="email-subscription">
          <FormControl onChange={this.handleChange} type="email" placeholder="Email Address" value={email} />
          {help && <HelpBlock style={{ clear: 'both' }}>{help}</HelpBlock>}
        </FormGroup>
        <Button type="submit">
          Go
        </Button>
      </form>
    );
  },

  handleChange(ev) {
    this.setState({ email: ev.target.value });
  },

  handleSubmit(ev) {
    ev.preventDefault();
    window.analytics.track('election_infographic', { email: this.state.email });
    this.setState({
      email: '',
      help: 'You will be notified for any future updates.'
    });
  }

});

export default EmailSubscription;




/** WEBPACK FOOTER **
 ** ./src/components/form/email_subscription.js
 **/